import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Label } from '@/components/ui/label'
import { Input } from '@/components/ui/input'
import { Textarea } from '@/components/ui/textarea'
import { Button } from '@/components/ui/button'
import { Loader2, Send, RefreshCw } from 'lucide-react'
import { useEmailDrafterStore } from '@/stores/email-drafter'

export function EmailForm() {
  const { session, isLoading, updateSession, sendEmailDraft, clearForm } = useEmailDrafterStore()

  const handleInputChange = (field: string, value: string) => {
    if (field.startsWith('systemprompt_')) {
      const promptField = field.replace('systemprompt_', '')
      updateSession({
        systemprompts: {
          ...session.systemprompts,
          [promptField]: value,
        },
      })
    } else {
      updateSession({ [field]: value })
    }
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    await sendEmailDraft()
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Email Draft Tester</CardTitle>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label htmlFor="email_address">Email Adresse *</Label>
              <Input
                id="email_address"
                type="email"
                value={session.emailAddress}
                onChange={(e) => handleInputChange('emailAddress', e.target.value)}
                placeholder="test@example.com"
                required
                disabled={isLoading}
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="email_name">Email Name *</Label>
              <Input
                id="email_name"
                type="text"
                value={session.emailName}
                onChange={(e) => handleInputChange('emailName', e.target.value)}
                placeholder="Max Mustermann"
                required
                disabled={isLoading}
              />
            </div>
          </div>

          <div className="space-y-2">
            <Label htmlFor="email_subject">Email Betreff</Label>
            <Input
              id="email_subject"
              type="text"
              value={session.emailSubject}
              onChange={(e) => handleInputChange('emailSubject', e.target.value)}
              placeholder="Betreff der Email"
              disabled={isLoading}
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="email_content">Email Content *</Label>
            <Textarea
              id="email_content"
              value={session.emailContent}
              onChange={(e) => handleInputChange('emailContent', e.target.value)}
              placeholder="Geben Sie hier den Email-Inhalt ein..."
              rows={6}
              required
              disabled={isLoading}
              className="resize-vertical"
            />
          </div>

          <div className="flex gap-2">
            <Button type="submit" disabled={isLoading} className="flex-1">
              {isLoading ? (
                <>
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                  Wird gesendet...
                </>
              ) : (
                <>
                  <Send className="mr-2 h-4 w-4" />
                  An Email Drafter senden
                </>
              )}
            </Button>
            <Button
              type="button"
              variant="outline"
              onClick={clearForm}
              disabled={isLoading}
            >
              <RefreshCw className="mr-2 h-4 w-4" />
              Formular zurücksetzen
            </Button>
          </div>
        </form>
      </CardContent>
    </Card>
  )
}